import { render, staticRenderFns } from "./ProductCompensationData.vue?vue&type=template&id=cde6fda2&"
import script from "./ProductCompensationData.vue?vue&type=script&lang=js&"
export * from "./ProductCompensationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports